/* eslint-disable complexity */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import React, { useContext, useEffect, useState } from 'react';
import Input from '../../components/Input/Input';
import GlobalContext from '../../contexts/GlobalContext';
import { useSubmitFormWithReCaptcha } from '../../hooks/custom';
import { usePostJson } from '../../hooks/services/regulatoryUpdateBundlePostJson';
import {
  errorInitialState,
  formPlaceholder,
  customerInfo,
  customerInitialState,
  SubmitButtonClassVlaue,
  SubmitButtonDisabledClassVlaue
} from '../../types/doNotSell';
import { emailRegex, phoneRegex } from '../../types/regulatoryUpdateBundle';
import { action } from '../../utils/regulatoryUpdatesBundle';
import PhoneEmailInput from '../PhoneEmailInput/PhoneEmailInput';
import {
  getPayloadObjectForDoNotSell,
  extractPhoneNumber
} from '../../utils/doNotSell';

type FormProps = {
  setSuccessPopUp: Function;
};

const Form = (props: FormProps): JSX.Element => {
  const [errorCondition, setErrorCondition] = useState(errorInitialState);
  const { globalContext } = useContext(GlobalContext);
  const [apiError, setApiError] = useState(false);
  const [customerObject, setCustomerObject] = useState(customerInitialState);
  const [submitClassValue, setSubmitClassValue] = useState(
    SubmitButtonClassVlaue
  );
  const submitFormWithReCaptcha = useSubmitFormWithReCaptcha();
  const onError = () => {
    setApiError(true);
    setSubmitClassValue(SubmitButtonClassVlaue);
  };
  const onSuccess = () => {
    props.setSuccessPopUp(true);
  };
  const [postJson] = usePostJson({ onSuccess: onSuccess, onError: onError });
  const getInputType = (value, name) => {
    setCustomerObject({ ...customerObject, [name]: value });
  };

  const setPhoneFormatterInputValue = (value) => {
    setCustomerObject({ ...customerObject, emailPhone: value });
  };

  const getValidation = () => {
    let result = true;
    let errorObj = errorCondition;

    if (customerObject.firstName === '') {
      errorObj = { ...errorObj, isFirstName: true };
      result = false;
    }

    if (customerObject.lastName === '') {
      errorObj = { ...errorObj, isLastName: true };
      result = false;
    }

    if (customerObject.emailPhone === '') {
      errorObj = { ...errorObj, isFieldBlank: true };
      setErrorCondition(errorObj);
      return false;
    } else {
      let phoneNumber = extractPhoneNumber(customerObject.emailPhone);
      if (
        !phoneRegex.test(phoneNumber) &&
        !isNaN(Number(phoneNumber)) &&
        phoneNumber.length !== 10
      ) {
        errorObj = { ...errorObj, isPhoneIncorrect: true };
        result = false;
      } else {
        if (
          !emailRegex.test(customerObject.emailPhone) &&
          !phoneRegex.test(phoneNumber)
        ) {
          errorObj = { ...errorObj, isEmailIncorrect: true };
          result = false;
        }
      }
    }

    setErrorCondition(errorObj);
    if (apiError) {
      setApiError(false);
    }

    return result;
  };
  const onSubmit = (e) => {
    e.preventDefault();

    if (getValidation()) {
      const userLoggedInStatus = globalContext.customer.uuid
        ? 'Loggedin'
        : 'Loggedout';
      submitFormWithReCaptcha(
        postJson,
        getPayloadObjectForDoNotSell({
          customer: customerObject,
          action: action
        })
      );
      setSubmitClassValue(SubmitButtonDisabledClassVlaue);
      globalContext.gtm.pushVersionedEvent(
        '2.11',
        'DoNotSellInformation',
        'ClickSubmitButton',
        'userLoggedInStatus=' + userLoggedInStatus,
        null,
        true
      );
    }
  };
  const removeErrorOnFocus = (value: string) => {
    let newErrorCondition = errorCondition;

    if (value === customerInfo.firstName) {
      newErrorCondition = { ...newErrorCondition, isFirstName: false };
    }

    if (value === customerInfo.lastName) {
      newErrorCondition = { ...newErrorCondition, isLastName: false };
    }

    if (value === customerInfo.emailPhone) {
      newErrorCondition = {
        ...newErrorCondition,
        isFieldBlank: false,
        isEmailIncorrect: false,
        isPhoneIncorrect: false
      };
    }

    setErrorCondition(newErrorCondition);
  };

  const phoneEmailInputProps = {
    inputValue: customerObject.emailPhone,
    placeHolder: formPlaceholder.emailPhone,
    inputType: 'emailPhone',
    setInputValue: setPhoneFormatterInputValue,
    useDefualtError: false,
    name: customerInfo.emailPhone,
    removeErrorOnFocusProp: removeErrorOnFocus
  };

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  useEffect(() => {}, [errorCondition]);

  return (
    <div className="regulatory-updates-modal__values">
      <div className="regulatory-updates-modal__values-area">
        <Input
          type="text"
          onChange={(e) => getInputType(e.target.value, customerInfo.firstName)}
          value={customerObject.firstName}
          placeholder={formPlaceholder.firstName}
          name={customerInfo.firstName}
          className="regulatory-updates__input-value real-time-val greyBackground"
          size={30}
          data-validate="text"
          aria-required="true"
          onFocus={() => removeErrorOnFocus(customerInfo.firstName)}
        />
        {errorCondition.isFirstName && (
          <span className="real-time-error">First Name cannot be empty.</span>
        )}
      </div>

      <div className="regulatory-updates-modal__values-area">
        <Input
          type="text"
          onChange={(e) => getInputType(e.target.value, customerInfo.lastName)}
          value={customerObject.lastName}
          placeholder={formPlaceholder.lastName}
          name={customerInfo.lastName}
          className="regulatory-updates__input-value real-time-val greyBackground"
          size={30}
          data-validate="text"
          aria-required="true"
          onFocus={() => removeErrorOnFocus(customerInfo.lastName)}
        />
        {errorCondition.isLastName && (
          <span className="real-time-error">Last Name cannot be empty.</span>
        )}
      </div>

      <div className="regulatory-updates-modal__values-area">
        <PhoneEmailInput {...phoneEmailInputProps} />
        {errorCondition.isFieldBlank && (
          <span className="real-time-error">Field cannot be empty.</span>
        )}
        {errorCondition.isEmailIncorrect && (
          <span className="real-time-error">Email Incorrect.</span>
        )}
        {errorCondition.isPhoneIncorrect && (
          <span className="real-time-error">Phone Incorrect.</span>
        )}
      </div>

      {apiError && <div className="real-time-error">Something went wrong</div>}

      <div>
        <button
          className={submitClassValue}
          type="submit"
          onClick={(e): void => onSubmit(e)}>
          submit
        </button>
      </div>
    </div>
  );
};

export default Form;
